import React from 'react';
import styled from 'styled-components';
import { Checkbox, FormControlLabelProps, FormControlLabel } from '@material-ui/core';
import { RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons';

const Label = styled(FormControlLabel)`
  margin-top: 12px;
`;

interface Props extends Omit<FormControlLabelProps, "control" | "color"> {
  color: "primary" | "secondary" | "default"
  label: string
}

const RadioButtonCheckbox: React.SFC<Props> = props => {
  return (
    <Label
      {...props}
      control={
        <Checkbox
          color={props.color}
          icon={<RadioButtonUnchecked />}
          checkedIcon={<RadioButtonChecked />}
        />
      }
      label={props.label}
    />
  )
}

export default RadioButtonCheckbox;
